import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './applyListDetail.module.scss';
import { Button } from 'antd-mobile-v5';
import { Toast } from 'antd-mobile';
import { ApiCore } from '../../api/index';
import { Checkbox } from 'antd-mobile-v5';
import assistant_doctor_avatar from '../../static/images_pfizer/assistant/assistant_doctor_avatar.png';
import already_reject from '../../static/images_pfizer/assistant/already_reject.png';
import already_pass from '../../static/images_pfizer/assistant/already_pass.png';
import commissioner from '../../static/images_pfizer/commissioner.png';
import volunteer from '../../static/images_pfizer/volunteer.png';
import nurse from '../../static/images_pfizer/nurse.png';
import utils from '../../utils/utils';
const api = new ApiCore();

function ApplyList(props: any) {

    const [agreementModal, setAgreementModal] = useState<boolean>(false);
    const [isRead, setIsRead] = useState<boolean>(false);
    const [locked, setLocked] = useState<boolean>(false);
    const [info, setInfo] = useState<any>({});

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])

    const initData = () => {
        const _urlParams = utils.getUrlParams() || {};
        if (_urlParams.id) {
            getDetail(_urlParams.id);
        }
    }

    const getDetail = (id: any) => {
        api.doctorApplyListDetail(id).then((res: any) => {
            if (res.code == 0) {
                setInfo(res.data || {});
            }
        })
    }

    //选择协议
    const handleGreement = () => {
        setAgreementModal(true)
    }

    //选择了阅读
    const handleRead = () => {
        if (!isRead) {
            setAgreementModal(true)
            setIsRead(false)
        }
        setIsRead(!isRead)
    }

    const toReject = () => {
        setLocked(true);
        !locked && api.doctorAssistantApplyListHandle({
            id: info.id,
            state: 'FAIL'
        }).then((res: any) => {
            if (res.code == 0) {
                Toast.info('操作成功', 0.8);
                initData();
            } else {
                Toast.info(res.message || '', 0.8);
            }
            setLocked(false);
        })
    }

    const toAgree = () => {
        setLocked(true);
        !locked && api.doctorAssistantApplyListHandle({
            id: info.id,
            state: 'PASS'
        }).then((res: any) => {
            if (res.code == 0) {
                Toast.info('操作成功', 0.8);
                initData();
            } else {
                Toast.info(res.message || '', 0.8);
            }
            setLocked(false);
        })
    }

    return (
        <div className={`${styles.applyListDetail_content}`}>
            <div className={styles.applyListWrap}>
                <div className={styles.applyList}>
                    <div className={styles.left}>
                        {
                            info.assistantType && 
                            <img src={info.assistantType == 'VOLUNTEER' ? volunteer : info.assistantType == 'NURSE' ? nurse : commissioner} alt="" />
                        }
                    </div>
                    <div className={styles.middle}>
                        <div className={styles.middle_top}>
                            <div>{info.assistantName}</div>
                        </div>
                        <div className={styles.middle_bottom}>
                            {
                                info.groupName &&
                                <div>
                                    申请成为{info.groupName}的{info.assistantTypeName}
                                </div>
                            }
                        </div>
                    </div>
                    {
                        info.state == 2 &&
                        <img className={styles.agree_status} src={already_pass} alt="" />
                    }
                    {
                        info.state == 3 &&
                        <img className={styles.agree_status} src={already_reject} alt="" />
                    }
                </div>
            </div>
            <div className={styles.assistant_info}>
                <div className={styles.assistant_info_title}>
                    <div></div><div>助理信息</div>
                </div>
                <div className={styles.info_item}>
                    <div>性别</div>
                    <div>{info.sex == 0 ? '女' : '男'}</div>
                </div>
                <div className={styles.info_item}>
                    <div>省份</div>
                    <div>{info.province}</div>
                </div>
                <div className={styles.info_item}>
                    <div>城市</div>
                    <div>{info.city}</div>
                </div>
                <div className={styles.info_item}>
                    <div>申请时间</div>
                    <div>
                        {
                            info.createTime ? info.createTime.slice(0, 10) : ''
                        }
                    </div>
                </div>
            </div>
            <div className={styles.apply_project}>
                <div className={styles.assistant_info_title}>
                    <div></div><div>申请项目</div>
                </div>
                <div className={styles.apply_project_content}>
                    <div>
                        {
                            info.groupName
                        }
                    </div>
                    <div>
                        {
                            info.remark
                        }
                    </div>
                </div>
            </div>
            {
               info.state == 1 &&
                <>
                    {/* <div className={styles.agreement}>
                        <Checkbox
                            style={{
                                '--icon-size': '20px',
                                '--font-size': '20px',
                                '--gap': '6px',
                            }}
                            className={styles.checkbox}
                            checked={isRead} 
                            onChange={handleRead}>
                        </Checkbox>
                        <span>&nbsp;&nbsp;我已阅读并同意</span>
                        <span className={styles.agreement_info} onClick={() => handleGreement()}>《授权管理协议》</span>
                    </div> */}
                    <div className={styles.apply_btns}>
                        <div>
                            <Button onClick={() => { toReject() }}>拒绝申请</Button>
                        </div>
                        <div>
                            <Button onClick={() => { toAgree() }}>同意申请</Button>
                        </div>
                    </div>
                </>
            }
        </div>
    )

}

export default ApplyList;